import { MapFiltersProvider } from "./filters/filterContext";
import { MapFilters } from "./filters/filters";
import { Map } from "./map";

interface Props {
	entityType?: string;
	entityId?: string;
}

export function Maps(props: Props) {
	const { entityType, entityId } = props;

	return (
		<MapFiltersProvider startingEntityType={entityType} startingEntityId={entityId}>
			<main className="tw-grid tw-grid-cols-4">
				<section className="tw-col-span-1">
					<MapFilters />
				</section>
				<section className="tw-col-span-3">
					<Map />
				</section>
			</main>
		</MapFiltersProvider>
	);
}
